﻿export default {
    methods: {
        fileAutoDownload(data, fileName) {
            let url = window.URL.createObjectURL(new Blob([data]));
            let link = document.createElement("a");

            link.href = url;
            link.setAttribute("download", fileName);

            document.body.appendChild(link);

            link.click();
            link.remove();
        },

        getFileNameFromAxiosResponseHeaders(responseHeaders) {
            if (!responseHeaders || !responseHeaders['content-disposition'])
                return '';

            const nameMatch = responseHeaders['content-disposition'].toString().match(/filename="?([^;"]*)/);
            const fileName = nameMatch instanceof Array && nameMatch.length >= 1 ? nameMatch[1] : ''; //nameMatch[1] - regex capture group

            return fileName;
        }
    }
};